// How-to videos, one per role, in English and Hindi. Same videos as the mobile app
// (teamplayer: lib/constants/tutorialVideos.ts) — keep the two lists in sync.
export const TUTORIAL_VIDEOS = {
  team_leader: { en: "qeDjef1cy_o", hi: "xtFgai0Ty2c" },
  team_player: { en: "k4ZlnbyRlAo", hi: "gZEb-e0ZSHw" },
};

/** "hi" when the web app is set to Hindi, otherwise "en". */
export const getVideoLanguage = () => {
  const lan = localStorage.getItem("language");
  return lan && lan.startsWith("hi") ? "hi" : "en";
};

export const youTubeEmbedUrl = (videoId) =>
  `https://www.youtube-nocookie.com/embed/${videoId}?rel=0&modestbranding=1`;

export const youTubeWatchUrl = (videoId) => `https://www.youtube.com/watch?v=${videoId}`;
